import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { Button } from "../../../../components";

const LiveProgramsSection = ({
  activeEnrollments = [],
  isChild = false,
  onEnrolClick,
  onShowDetailsClick,
  onBookDemoClick,
}) => {
  return (
    <div className="space-y-4 text-left">
      <h3 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
        Live Programs
      </h3>

      <div className="relative overflow-hidden rounded-3xl bg-[#DBF2F7] border border-[#BCE3EB] p-6 sm:p-8 shadow-xs hover:shadow-md transition-all duration-300">
        {/* Decorative background blobs/glows */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-100/50 rounded-full blur-2xl -ml-16 -mb-16 pointer-events-none" />

        <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="space-y-3 max-w-3xl">
            {/* Badge */}
            <div className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs font-black tracking-wider uppercase shadow-3xs">
              <Sparkles className="w-3.5 h-3.5 text-amber-300 animate-pulse" />
              <span>Practido AI LAB Program</span>
            </div>

            {/* Headline */}
            <h4 className="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900">
              {activeEnrollments.length > 0
                ? isChild
                  ? "Enrol in a Live Online Course"
                  : "Enrol More Children in a Live Online Course"
                : isChild
                ? "Enrol in a Live Online Course"
                : "Enrol Your Child in a Live Online Course"}
            </h4>

            {/* Subheadline */}
            <p className="text-sm md:text-base text-slate-600 leading-relaxed font-medium">
              {activeEnrollments.length > 0
                ? isChild
                  ? "Select your course, complete payment, and we'll confirm your first class within 24 hours - directly on WhatsApp."
                  : "Add more children, select their courses, complete payment, and we’ll confirm their classes within 24 hours - directly on WhatsApp."
                : isChild
                ? "Select your course, complete payment, and we'll confirm your first class within 24 hours - directly on WhatsApp."
                : "Select your course, complete payment, and we’ll confirm your child’s first class within 24 hours - directly on WhatsApp."}
            </p>

            {/* Show Details (below text) */}
            <div className="pt-1">
              <button
                type="button"
                onClick={onShowDetailsClick}
                className="text-xs font-black text-blue-700 hover:text-blue-900 inline-flex items-center gap-1 group transition-all cursor-pointer"
              >
                <span>Show Details</span>
                <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
              </button>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center sm:items-end md:items-center gap-3 flex-shrink-0 self-center w-full sm:w-auto">
            <Button
              version="secondary"
              text={activeEnrollments.length > 0 ? "Enrol More Children" : "Enrol Now"}
              handleClick={onEnrolClick}
              className="w-full sm:w-auto font-bold px-6 py-3 rounded-xl shadow-sm"
            />
            <button
              type="button"
              onClick={onBookDemoClick}
              className="text-xs font-black text-blue-700 hover:text-blue-900 inline-flex items-center gap-1.5 group transition-all pt-1 cursor-pointer"
            >
              <Sparkles className="w-3.5 h-3.5 text-amber-500 animate-pulse" />
              <span>Book Free Demo</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveProgramsSection;
